import React from 'react';
import PropTypes from 'prop-types';

import { assemblyPropType } from '../../../../../../fitment-by-vehicle-util';
import FitmentTireSizeOption from '../../../fitment-tire-size-option/fitment-tire-size-option';

function OptionalSizeGroup(props) {
  const {
    className = '',
    groupSizes,
    selectedOptionalSize,
    setSelectedOptionalSize
  } = props;

  if (!Array.isArray(groupSizes)) return null;

  return (
    <div className={`optional-size-group ${className}`} role="radiogroup">
      {groupSizes.map((optionalSizes, idx) => {
        if (Array.isArray(optionalSizes)) {
          return (
            <div className="optional-size-group__sizes" key={`osg-${idx}`}>
              {optionalSizes.map(optionalSize => (
                <FitmentTireSizeOption
                  assembly={optionalSize}
                  isNormalizedSize
                  key={`optional-size-${optionalSize.id}`}
                  onClick={setSelectedOptionalSize}
                  selectedAssembly={selectedOptionalSize}
                />
              ))}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}

OptionalSizeGroup.propTypes = {
  className: PropTypes.string,
  groupSizes: PropTypes.arrayOf(PropTypes.arrayOf(assemblyPropType)),
  selectedOptionalSize: assemblyPropType,
  setSelectedOptionalSize: PropTypes.func
};

export default OptionalSizeGroup;
